import {castArray, range} from 'lodash';
import {useCallback, useMemo} from 'react';
import {Range, getTrackBackground} from 'react-range';
import {IThumbProps, ITrackProps} from 'react-range/lib/types';

import {themeConfig} from 'constants/theme';

type Props = {
    value?: number,
    min: number,
    max: number,
    stepsCount?: number,
    step?: number,
    hasLabels?: boolean;
    onChange?: (value: number) => void,
}

export const InputRange: React.FC<Props> = ({
    value, min, max, stepsCount: stepsCountProp, hasLabels = false, step = 1, onChange
}: Props) => {

    const stepsCount = useMemo(() => stepsCountProp || Math.ceil(((max + 1) - min) / step), [stepsCountProp, max, min, step]);
    const rangeValues = useMemo(() => [value], [value]);

    const rangeStyle = useMemo(() => (
        {
            background: getTrackBackground({
                values: castArray(value),
                min,
                max,
                colors: [themeConfig.colors.primary, themeConfig.colors.lightGray]
            })
        }
    ), [max, min, value]);

    const renderThumb = useCallback((params: {props: IThumbProps}) => (
        <div
            {...params.props}
            className='tw-bg-default tw-rounded-full tw-border-4 tw-border-primary tw-h-5 tw-w-5'
        />
    ), []);

    const renderTrack = useCallback((params: {props: ITrackProps, children: React.ReactNode}) => (
        <div
            {...params.props}
            className='tw-h-2 tw-w-full tw-rounded'
            style={rangeStyle}
        >
            {params.children}
        </div>
    ), [rangeStyle]);

    return (
        <div className='tw-w-full'>
            {hasLabels &&
                <div className='tw-flex tw-text-default tw-justify-between tw-w-full tw-mb-2'>
                    {range(stepsCount).map((element) => <span key={element}>{element}</span>)}
                </div>}
            <div className='tw-px-2'>
                <Range
                    step={step}
                    min={min}
                    max={max}
                    values={rangeValues}
                    renderTrack={renderTrack}
                    renderThumb={renderThumb}
                    onChange={(values) => onChange(values[0])}
                />
            </div>
        </div>
    );
};
